export const CONSULTATION_OFFER_SCOPE = 'findMyAgentConsultationOffer';

export const CONSULTATION_OFFER_TICK_KEYS: readonly string[] = ['ticks.free', 'ticks.noContact', 'ticks.ranked'];

/** Outlives the session, so a visitor who says no is not asked again on this device. */
export const CONSULTATION_OFFER_DISMISSED_KEY = 'rma.consultation-offer.dismissed';

export const CONSULTATION_OFFER_SHOWN_KEY = 'rma.consultation-offer.shown';

/**
 * Anchor both ends of anything added here: unanchored, an opted-in path matches as a later segment
 * or as a longer word. The five prefixes lazy-load child tables that add segments, hence `(\/.*)?`.
 */
export const CONSULTATION_OFFER_PATHS: readonly RegExp[] = [
  /^\/$/,
  /^\/search$/,
  /^\/real-estate-profile\/sales(\/.*)?$/,
  /^\/real-estate-profile\/leasing(\/.*)?$/,
  /^\/finance(\/.*)?$/,
  /^\/real-estate-agent\/[^/]+\/sales(\/.*)?$/,
  /^\/real-estate-agency\/[^/]+\/sales(\/.*)?$/,
];

export function isConsultationOfferPath(url: string): boolean {
  // `Router.url` carries the query string and fragment, and a utm-tagged landing URL is the same page.
  const path = url.split(/[?#]/)[0];

  return CONSULTATION_OFFER_PATHS.some((pattern) => pattern.test(path));
}

export const CONSULTATION_OFFER_DWELL_MS = 3000;

export const CONSULTATION_OFFER_SCROLL_RATIO = 0.25;

export const CONSULTATION_OFFER_CATEGORY = 'find_my_agent';

export const CONSULTATION_OFFER_EVENTS = {
  shown: 'consultation_offer_shown',
  dismissed: 'consultation_offer_dismissed',
  clicked: 'consultation_offer_clicked',
} as const;

export type ConsultationOfferEngagement = 'scroll-depth' | 'second-navigation';
